import { AxiosResponse } from 'axios';
import { api } from '../../../../api/axiosInstance';
import { KeywordRepository } from '../../Domain/Repositories/KeywordRepository';
import { KeywordOptimizationRequest, KeywordOptimizationResponse } from '../../Model/KeywordOptimization';

export class KeywordRepositoryImpl implements KeywordRepository {
  async optimizeKeywords(request: KeywordOptimizationRequest): Promise<KeywordOptimizationResponse> {
    const response: AxiosResponse<KeywordOptimizationResponse> = await api.post(
      '/utils/keyword-optimization/',
      request
    );
    return response.data;
  }
}
